import { rpcClient } from 'src/api/rpc/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'src/context/ToastContext';

export function useReprocessInboundEmail() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async (inboundEmailId: string) => {
      return rpcClient.communications.inboundEmails.reprocess({
        inboundEmailId,
      });
    },
    onSuccess: () => {
      // Invalidate inbound emails list to refresh status
      queryClient.invalidateQueries({ queryKey: ['inboundEmails'] });

      showToast({
        message: 'Email queued for reprocessing',
        color: 'success',
        icon: 'check_circle',
      });
    },
    onError: (error) => {
      console.error('Failed to reprocess email:', error);
      showToast({
        message: 'Failed to reprocess email',
        color: 'error',
        icon: 'error',
      });
    },
  });
}
